export const REQUEST_NEW_DUE_DATE = "REQUEST_NEW_DUE_DATE";
export const REQUEST_NEW_DUE_DATE_SUCCEEDED = "REQUEST_NEW_DUE_DATE_SUCCEEDED";
export const REQUEST_NEW_DUE_DATE_FAILED = "REQUEST_NEW_DUE_DATE_FAILED";

export const requestNewDueDate = (requestNewDueDate, isFromIncomplete) => {
    return {
        type: REQUEST_NEW_DUE_DATE,
        requestNewDueDate,
        isFromIncomplete,
    };
};

export const requestNewDueDateSucceeded = (requestNewDueDateResponse) => {
    return {
        type: REQUEST_NEW_DUE_DATE_SUCCEEDED,
        requestNewDueDateResponse,
    };
};

export const requestNewDueDateFailed = (message) => {
    return {
        type: REQUEST_NEW_DUE_DATE_FAILED,
        message,
    };
};
